/* assets/mr-page-loader.js
   Maison Roziere — Persisted Page Loader (Reusable)
*/

(function () {
  if (window.__MR_PageLoader_Bound) return;
  window.__MR_PageLoader_Bound = true;

  var PAGE_LOADER_ID = "mr-page-loader";
  var STYLES_ID = "mr-page-loader-styles";

  function ensureStyles() {
    if (document.getElementById(STYLES_ID)) return;

    var css = document.createElement("style");
    css.id = STYLES_ID;
    css.textContent = `
      #${PAGE_LOADER_ID}{
        position: fixed;
        inset: 0;
        z-index: 100002;
        display: none;
        opacity: 0;
        transition: opacity .22s ease;
      }
      #${PAGE_LOADER_ID}.is-visible{
        display:block;
        opacity: 1;
      }

      #${PAGE_LOADER_ID} .mr-pl__overlay{
        position:absolute;
        inset:0;
        background: rgba(0,0,0,0.62);
        backdrop-filter: blur(3px);
      }

      #${PAGE_LOADER_ID} .mr-pl__panel{
        position:absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
        width: min(520px, calc(100vw - 2rem));
        background: rgb(var(--background));
        border: 1px solid rgba(0,0,0,0.10);
        border-radius: 18px;
        box-shadow: 0 18px 60px rgba(0,0,0,0.40);
        padding: 1.15rem 1.25rem;
        text-align: center;
      }

      #${PAGE_LOADER_ID} .mr-pl__label{
        font-size: 0.72rem;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        opacity: 0.78;
        margin-bottom: 0.65rem;
      }

      #${PAGE_LOADER_ID} .mr-pl__row{
        display:flex;
        align-items:center;
        justify-content:center;
        gap: 0.6rem;
      }

      #${PAGE_LOADER_ID} .mr-pl__spinner{
        width: 18px;
        height: 18px;
        border-radius: 999px;
        border: 2px solid rgba(0,0,0,0.18);
        border-top-color: rgba(0,0,0,0.60);
        animation: mrplspin .8s linear infinite;
      }

      #${PAGE_LOADER_ID} .mr-pl__text{
        font-size: 0.92rem;
        line-height: 1.5;
        opacity: 0.88;
      }

      @keyframes mrplspin { to { transform: rotate(360deg); } }

      @media (prefers-reduced-motion: reduce){
        #${PAGE_LOADER_ID}{ transition: none; }
        #${PAGE_LOADER_ID} .mr-pl__spinner{ animation: none; }
      }
    `;
    document.head.appendChild(css);
  }

  function ensureEl() {
    ensureStyles();
    var el = document.getElementById(PAGE_LOADER_ID);
    if (el) return el;

    el = document.createElement("div");
    el.id = PAGE_LOADER_ID;
    el.setAttribute("aria-hidden", "true");
    el.innerHTML =
      '<div class="mr-pl__overlay"></div>' +
      '<div class="mr-pl__panel" role="status" aria-live="polite">' +
        '<div class="mr-pl__label" data-mr-pl-label>Client Services Note</div>' +
        '<div class="mr-pl__row">' +
          '<div class="mr-pl__spinner" aria-hidden="true"></div>' +
          '<div class="mr-pl__text" data-mr-pl-text>Loading…</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(el);
    return el;
  }

  function lockScroll(lock) {
    try { document.documentElement.style.overflow = lock ? "hidden" : ""; } catch (e) {}
  }

  function show(opts) {
    opts = opts || {};
    var el = ensureEl();

    var label = opts.label || "Client Services Note";
    var text = opts.text || "Loading…";

    var labelEl = el.querySelector("[data-mr-pl-label]");
    var textEl = el.querySelector("[data-mr-pl-text]");
    if (labelEl) labelEl.textContent = label;
    if (textEl) textEl.textContent = text;

    el.classList.add("is-visible");
    el.setAttribute("aria-hidden", "false");
    lockScroll(true);
  }

  function hide() {
    var el = document.getElementById(PAGE_LOADER_ID);
    if (!el) return;

    el.classList.remove("is-visible");
    el.setAttribute("aria-hidden", "true");
    lockScroll(false);
  }

  // Public API
  window.MRPageLoader = {
    show: show,
    hide: hide
  };
})();
